import type { FC } from 'react';
import { Circle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const BedVacantBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-emerald-600 text-white">
      <Circle aria-hidden className="size-3 shrink-0" />
      {t('component:badge.bedVacant')}
    </Badge>
  );
};
